import { setLoading } from "../../common/Loader/slice";
import requestUtil from "../../../helpers/requestUtil";
import {
    getTimeZoneDropdownSuccess,
    getTimeZoneDropdownError,
    getTravelDistanceSuccess,
    getTravelDistanceError,
    getEMREHRListSuccess,
    getEMREHRListError,
    addNewLocationSuccess,
    addNewLocationError,
    editLocationSuccess,
    editLocationError,
    setAction,
    setMapCandidate,
    getZipCodeInfoSuccess,
    getZipCodeInfoError,
    setLocationsId,
    setSaveButtonDisabled,
    setLoadingFlagDecrement,
    setLoadingFlagIncrement
} from "./slice";
import { toast } from "react-toastify";
import { setHeaderState } from "../../common/Header/slice";
import { updateSharedSlice } from "../../shared/sharedSlice";

//let employerdId = 1003;

export function getTimeZoneDropdownList(url) {
    return async (dispatch) => {
        // dispatch(setLoading(true));
        // requestUtil(`${url}/Dropdown/gettimezoneinfo`, "GET")
        //     .then((response) => {
        //         dispatch(getTimeZoneDropdownSuccess(response));
        //     }).catch((error) => {
        //         dispatch(getTimeZoneDropdownError(error.message));
        //         dispatch(setLoading(false));
        //     });
        // dispatch(setLoading(false));
        dispatch(setLoadingFlagIncrement())
        try {
            const response = await requestUtil(`${url}/Dropdown/gettimezoneinfo`, "GET")
            dispatch(getTimeZoneDropdownSuccess(response));
        } catch(error){
            dispatch(getTimeZoneDropdownError(error.message));
        } finally {
            dispatch(setLoadingFlagDecrement())
        }
    };
}

export function getTravelDistanceList(url) {
    return async (dispatch,getState) => {
        // dispatch(setLoading(true));
        // requestUtil(`${url}/Dropdown/GetTravelDistances`, "GET")
        //     .then((response) => {
        //         dispatch(getTravelDistanceSuccess(response));
        //     }).catch((error) => {
        //         dispatch(getTravelDistanceError(error.message));
        //         dispatch(setLoading(false));
        //     });
        // dispatch(setLoading(false));
        const state = getState();
        const distanceSharedList = state.shared.distanceSharedList;
        let response = distanceSharedList ?? [];
        try {
        dispatch(setLoadingFlagIncrement())
        if(response?.length === 0){
            response = await requestUtil(`${url}/Dropdown/GetTravelDistances`, "GET");
            dispatch(updateSharedSlice({name:"distanceSharedList",value:response}));
        }
            dispatch(getTravelDistanceSuccess(response));
        } catch(error){
            dispatch(getTravelDistanceError(error.message));
        } finally {
            dispatch(setLoadingFlagDecrement())
        }
    };
}

export function getEMREHRList(url, empId) {
    return async (dispatch) => {
        // dispatch(setLoading(true));
        // requestUtil(`${url}/Locations/getemrehrsystems/${empId}`, "GET")
        //     .then((response) => {
        //         dispatch(getEMREHRListSuccess(response));
        //     }).catch((error) => {
        //         dispatch(getEMREHRListError(error.message));
        //         dispatch(setLoading(false));
        //     });
        // dispatch(setLoading(false));
        dispatch(setLoadingFlagIncrement())
        try {
            const response = await requestUtil(`${url}/Locations/getemrehrsystems/${empId}`, "GET")
            dispatch(getEMREHRListSuccess(response));
        } catch(error){
            dispatch(getEMREHRListError(error.message));
        } finally {
            dispatch(setLoadingFlagDecrement())
        }
    };
}

export function addNewLocation(url, locationInfo, action) {
    return async (dispatch) => {
        // dispatch(setLoading(true));
        // dispatch(setSaveButtonDisabled(true));
        // requestUtil(`${url}/Locations/add`, "POST", locationInfo)
        //     .then((response) => {
        //         //dispatch(setAction(action));
        //         dispatch(addNewLocationSuccess(response));
        //         dispatch(setLocationsId(response.locationId))
        //         dispatch(setSaveButtonDisabled(false));
        //     }).catch((error) => {
        //         dispatch(addNewLocationError(error.message));
        //         dispatch(setLoading(false));
        //         dispatch(setSaveButtonDisabled(false));
        //     });
        // dispatch(setLoading(false));
        dispatch(setLoadingFlagIncrement());
        dispatch(setSaveButtonDisabled(true));

        try {
            const response = await requestUtil(`${url}/Locations/add`, "POST", locationInfo)
            dispatch(addNewLocationSuccess(response));
            dispatch(setLocationsId(response.locationId))
            return response;
        } catch(error){
            dispatch(addNewLocationError(error.message)); 
        } finally {
            dispatch(setLoadingFlagDecrement())
        dispatch(setSaveButtonDisabled(false));
        }
    };
}

export function editLocation(url, locationInfo, action) {
    return async (dispatch) => {
        // dispatch(setLoading(true));
        // requestUtil(`${url}/Locations/update`, "POST", locationInfo)
        //     .then((response) => {
        //         dispatch(editLocationSuccess(response));
        //     }).catch((error) => {
        //         dispatch(editLocationError(error.message));
        //         dispatch(setLoading(false));
        //     });
        // dispatch(setLoading(false));
        dispatch(setLoadingFlagIncrement())
        try {
            const response = await requestUtil(`${url}/Locations/update`, "POST", locationInfo)
            dispatch(editLocationSuccess(response));
        } catch(error){
            dispatch(editLocationError(error.message));
        } finally {
            dispatch(setLoadingFlagDecrement())
        }
    };
}

export const saveMapLatAndLng = ({ url, val }) => {
    return async dispatch => {
        // dispatch(setLoading(true));
        // try {
        //     const response = await requestUtil(`${url}`, 'POST', val);
        // } catch (error) {

        // }
        // dispatch(setLoading(false));
        dispatch(setLoadingFlagIncrement())
        try {
            const response = await requestUtil(`${url}`, 'POST', val);
        } catch(error){
        } finally {
            dispatch(setLoadingFlagDecrement())
        }
    }
}

export const getMapCandiadates = ({ url, val }) => {
    return async dispatch => {
        // dispatch(setLoading(true));
        // try {
        //     const response = await requestUtil(`${url}`, 'POST', val);
        //     dispatch(setMapCandidate(response.locationMapCandidateList));
        // } catch (error) {

        // }
        // dispatch(setLoading(false));
        dispatch(setLoadingFlagIncrement())
        try {
            const response = await requestUtil(`${url}`, 'POST', val)
            dispatch(setMapCandidate(response.locationMapCandidateList));
        } catch(error){
            console.log(error)
        } finally {
            dispatch(setLoadingFlagDecrement())
        }
    }
}


export function getZipCodeInfo(url, zipcode) {
    return async (dispatch) => {
        // dispatch(setLoading(true));
        // requestUtil(`${url}/Zipcodes/getzipcodeinfo/${zipcode}`, "GET")
        // .then((response) => {
        //         dispatch(getZipCodeInfoSuccess(response));
        //     }).catch((error) => {
        //         dispatch(getZipCodeInfoError(error.message));
        //         dispatch(setLoading(false));
        //     });
        // dispatch(setLoading(false));
        dispatch(setLoadingFlagIncrement())
        try {
            const response = await requestUtil(`${url}/Zipcodes/getzipcodeinfo/${zipcode}`, "GET")
            dispatch(getZipCodeInfoSuccess(response));
        } catch(error){
            dispatch(getZipCodeInfoError(error.message));
        } finally {
            dispatch(setLoadingFlagDecrement())
        }
    };
}


// Break Type List
export function getBreakTypeList(url) {
    return async (dispatch) => {
        dispatch(setLoadingFlagIncrement())
        try {
            const response = await requestUtil(`${url}/Dropdown/get-breaktype`, "POST")
            return response;
        } catch(error){
            console.log(error.message);
        } finally {
            dispatch(setLoadingFlagDecrement())
        }
    };
}


export const editBreakTypeList = ( url, params ) => {
    return async dispatch => {
        dispatch(setLoadingFlagIncrement())
        try {
          const response = await requestUtil(`${url}`, 'POST', {...params})
            toast.success(response.message)
        } catch(error){
            toast.error(error.message)
        } finally {
            dispatch(setLoadingFlagDecrement())
        }
    }
}


export function getLocationFilterList(url, employerId, employerUniqueId, id) {
    return async (dispatch) => {
        dispatch(setLoadingFlagIncrement())

        try {
            const response = await  requestUtil(`${url}/Locations/getlocationlist`, "POST", 
                {
                    "page": 0,
                    "pageSize": 0,
                    "sortOrder": "string",
                    "sortColumn": "string",
                    "employerId": employerId,
                    "employerUniqueId": employerUniqueId,
                    "searchText": 0
                });
           const filterResult = response?.locations?.find(item => item.locationId === id);
           return filterResult
        }
        catch(error){
            console.log(error.message);
        } finally {
            dispatch(setLoadingFlagDecrement())

        }
    };
}

export const getLocationList = ({baseUrl,empID}) => {
    return async(dispatch) => {
      dispatch(setLoading(true));
      try {
        const result = await requestUtil(`${baseUrl}/Locations/get-location-list-for-dropdown/${empID}`);
        const allLocationList = [{id: 0, name: "All"},...result]
        dispatch(setHeaderState({name:"locationMasterList",value:result}));
        dispatch(updateSharedSlice({name:"locationSharedList",value:result}))
        dispatch(updateSharedSlice({name:'locationDashboardSharedList',value:allLocationList}));
        // dispatch(updateSharedSlice({name:""}))
        return result;
      } catch (error) {
        return error.message
      } finally{
        dispatch(setLoading(false));
      }
    }
  }